import { range } from "@punks/core"
import React from "react"
import { CustomCol, CustomRow } from "../../../spacings"
import ProductGridItemSkeleton from "../ProductGridItemSkeleton"

interface Props {
  tot: number
  colXs?: number
  colSm?: number
}

const ProductGridSkeleton = ({ tot, colSm, colXs }: Props) => {
  return (
    <CustomRow>
      {range(1, tot).map((x) => (
        <CustomCol key={x} xs={colXs} sm={colSm}>
          <div className="px-2 mb-12">
            <ProductGridItemSkeleton />
          </div>
        </CustomCol>
      ))}
    </CustomRow>
  )
}

export default ProductGridSkeleton
